import { isFeatureEnabled } from 'utils'
import { FEATURES } from 'config'

export default function useReferralEnabled() {
  return isFeatureEnabled(FEATURES.REFERRAL_PROGRAM)
}

